export const mimeTypeLeft = mime => {
	return mime.split('/')[0];
};
export const isNotFileAllowed = file => {
	const ext = file.name.split('.').pop();
	return !['jpg', 'png','PNG', 'jpeg', 'gif', 'bmp'].includes(ext);
};

export const urlFormatHelper = (url) => {
	let multChat = 'chats';
	if (url.includes(multChat)){
		let index0 = url.indexOf('chats');
		let host = window.location.protocol + '//' + (window.location.hostname === 'localhost' ? '192.168.1.33' : window.location.hostname) + '/chats';
		let subUrl = url.substr(index0 + multChat.length);
		return host + subUrl;
	}
	return url;
};